<ion-row>
  <ion-col>
    <ion-text color="primary"><h2>{{'CROSSWORD_'+ data.configPreset +'.help_dialog.title' | translate}}</h2></ion-text>
    <ion-text [innerHTML]="'CROSSWORD_'+ data.configPreset +'.help_dialog.text' | translate"></ion-text>
  </ion-col>
</ion-row>
<ion-row>
  <ion-col>
    <br/>
    <ion-text color="primary"><h2>{{"CROSSWORD.help_dialog.game_mechanics" | translate }}</h2></ion-text>
  </ion-col>
</ion-row>
<ion-row *ngFor="let category of categories">
  <ion-col>
    <ion-text color="primary"><h6>{{('CROSSWORD.help_dialog.mechanics.' + category + '.title')|translate}}</h6></ion-text>
    <ion-text *ngIf="category === 'play'" [innerHTML]="['CROSSWORD.help_dialog.mechanics.play.text', data.definFields === 'show' ? 'show_defin' : 'hide_defin'].join('.') | translate"></ion-text>
    <ion-text *ngIf="['drag_drop', 'word_list', 'defin_list'].indexOf(category) !== -1" [innerHTML]="['CROSSWORD.help_dialog.mechanics', category, 'text'].join('.') | translate"></ion-text>
    <ion-text *ngIf="category === 'zoom'" [innerHTML]="['CROSSWORD.help_dialog.mechanics', category, 'text', device, device === 'mobile' ? 'any' : browser ].join('.') | translate"></ion-text>
    <ion-text *ngIf="['move', 'direction_change'].indexOf(category) !== -1" [innerHTML]="['CROSSWORD.help_dialog.mechanics', category, 'text', device].join('.') | translate"></ion-text>
  </ion-col>
</ion-row>
